import { Table } from 'antd';
import styled from 'styled-components';

export const PipelinesContainer = styled.div`
  margin: 16px;
  padding: 24px;
  border-radius: 4px;
  background: #fff;
`;

export const TableActionsWrapper = styled.div`
  min-width: 100px;
  display: flex;
  gap: 18px;
  font-size: 20px;

  .disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TableNextScheduleWrapper = styled.div`
  min-width: 155px;
`;

export const TableLastRunStatusWrapper = styled.div`
  width: 135px;

  p {
    margin: 0;
  }

  .status-text {
    line-height: 20px;

    &.completed {
      color: var(--green-green-6, #71c969);
    }
    &.failed {
      color: var(--red-red-7, #e84d42);
    }
  }
`;

export const TableStatusWrapper = styled.div`
  width: 65px;

  p {
    margin: 0;
  }
  .piepline-status-text {
    line-height: 20px;

    &.active {
      color: var(--green-green-6, #71c969);
    }
  }
`;

export const TableStyled = styled(Table)`
  .ant-table-thead {
    /* Fix the table header at the top */
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .ant-table-content {
    border-left: 1px solid #eceff4;
    border-right: 1px solid #eceff4;
    height: 500px;
    overflow: auto;

    /* Customize the scrollbar */
    ::-webkit-scrollbar {
      width: 3px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #bbb;
      border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: #999;
    }
  }

  .ant-table-thead {
    tr {
      th {
        font-size: 12px;
        line-height: 1;
        color: var(--grey2, #748aa1);
        background: var(--light-grayish-blue-color11, #eef4fa);
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: #eceff4;
        padding: 10px 16px;
      }
    }
  }

  .ant-table-tbody {
    tr {
      td {
        color: var(--grey-1-text, #31394d);
        font-size: 13px;
        line-height: 20px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: #eceff4;
        padding: 12px 16px;
        word-break: break-word;

        .finalValue-input {
          min-width: 200px;
        }
      }
    }
  }
`;

export const PipelinesHistoryHeaderContainer = styled.div`
  .title {
    color: #556069;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  .refresh-button {
    margin-left: 35px;
  }
`;

export const PipelinesHistoryContentContainer = styled.div`
  P {
    margin: 0px;
  }

  .view-link-button {
    margin-top: 8px;
    padding: 0px;
    color: #007bff;
  }

  .error-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    margin-top: 12px;

    .title {
      color: #556069;
      font-size: 14px;
      font-weight: 700;
      line-height: 20.5px;
      text-decoration-line: underline;
    }

    .error-text {
      color: #ce1111;
      font-size: 10px;
      line-height: 20.5px;
      overflow-wrap: anywhere;
    }
  }

  .pipeline-history-table-pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0 0;

    .ant-pagination-item-container {
      width: 100%;
    }

    .ant-pagination-total-text {
      p {
        color: var(--grey-3-text, #b8bec5);
        line-height: 32px;
        margin: 0;
      }
    }

    .ant-pagination-item,
    button.ant-pagination-item-link {
      border-radius: 4px;
      border: 1px solid var(--grey-5-border, #d0d7e3);
    }

    .ant-pagination-options-size-changer .ant-select-selector {
      border-radius: 4px;
      border: 1px solid var(--grey-5-border, #d0d7e3);
    }

    .ant-pagination-options-size-changer.ant-select-focused
      .ant-select-selector {
      border: 1px solid var(--brand-2, #21b4bd);
      box-shadow: 0 0 0 2px var(--brand-2-02, #21b4bd33);
    }

    .ant-pagination-item-active {
      border: 1px solid var(--brand-2, #21b4bd);
    }
  }
`;

export const HistoryTableStyled = styled(Table)`
  thead {
    display: none;
  }
`;
